import { KeyboardDateTimePicker, MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
const moment = window.moment;

interface DatePickerProps {
	dateFormat: string;
	dateTimeFormat?: string;
	label?: string;
	disabled?: boolean;
	onChange: (date: MaterialUiPickersDate, value?: string | null | undefined) => void;
	timeFormat?: string;
	minDate?: Date;
	maxDate?: Date;
	selected?: Date;
	dataType?: string;
	placeholder?: string;
	error?: string;
	mandatory?: boolean;
	classes: any;
	name?: string;
	important?: string;
	className?: string;
	helperText?: string;
}

class NewDatePicker extends window.React.PureComponent<DatePickerProps> {
	constructor(props: DatePickerProps) {
		super(props);
		moment.locale(window?.Alfresco?.constants?.JS_LOCALE ?? 'cs');
	}

	// @ts-ignore
	static defaultProps: DatePickerProps = {
		dataType: 'date',
		dateFormat: window.Edocat.Config?.dateFormat || window.Edocat.texts?.dateTimeFormat,
		dateTimeFormat: window.Edocat.Config?.dateTimeFormat,
		mandatory: false,
	};

	render() {
		const {
			dateFormat,
			label,
			disabled,
			minDate,
			maxDate,
			dataType,
			dateTimeFormat,
			selected,
			placeholder,
			error,
			onChange,
			mandatory,
			name,
			important,
			helperText,
			className,
		} = this.props;

		const dateError =
			selected && !(selected.hasOwnProperty('_isValid') ? selected : moment(selected))._isValid
				? window.Alfresco.messages.global['Alfresco.forms.validation.date.message']
				: '';

		return (
			<div className="Global-Date-Picker">
				{dataType === 'date' ? (
					<MuiPickersUtilsProvider
						libInstance={moment}
						utils={MomentUtils}
						locale={window.Alfresco.constants.JS_LOCALE}
					>
						<KeyboardDatePicker
							className={className}
							cancelLabel={window.Alfresco.messages.global['button.cancel']}
							clearable={!mandatory}
							clearLabel={window.Alfresco.messages.global['button.clear']}
							disabled={disabled}
							error={!!error || !!dateError}
							format={dateFormat}
							helperText={error || dateError || important || helperText}
							label={label}
							required={mandatory}
							maxDate={maxDate || undefined}
							minDate={minDate || undefined}
							okLabel={window.Alfresco.messages.global['button.ok']}
							placeholder={placeholder}
							onChange={value => onChange(value ? value.startOf('day') : value)}
							value={selected}
							id={name}
							type="text"
							inputVariant="outlined"
							KeyboardButtonProps={{
								disableFocusRipple: true,
								disableRipple: true,
								style: {
									backgroundColor: 'transparent',
									paddingRight: '5px',
									paddingLeft: 0,
								},
							}}
						/>
					</MuiPickersUtilsProvider>
				) : (
					<MuiPickersUtilsProvider
						libInstance={moment}
						utils={MomentUtils}
						locale={window.Alfresco.constants.JS_LOCALE}
					>
						<KeyboardDateTimePicker
							ampm={false}
							className={className}
							cancelLabel={window.Alfresco.messages.global['button.cancel']}
							clearable={!mandatory}
							clearLabel={window.Alfresco.messages.global['button.clear']}
							disabled={disabled}
							error={!!error || !!dateError}
							format={dateTimeFormat}
							helperText={error || dateError || important || helperText}
							required={mandatory}
							label={label}
							maxDate={maxDate || undefined}
							minDate={minDate || undefined}
							okLabel={window.Alfresco.messages.global['button.ok']}
							onChange={onChange}
							placeholder={placeholder}
							value={selected}
							id={name}
							inputVariant="outlined"
							KeyboardButtonProps={{
								disableFocusRipple: true,
								disableRipple: true,
								style: {
									backgroundColor: 'transparent',
									paddingRight: '5px',
									paddingLeft: 0,
								},
							}}
						/>
					</MuiPickersUtilsProvider>
				)}
			</div>
		);
	}
}

export default NewDatePicker;
